import { render, staticRenderFns } from "./MyPortfoliosWrapper.vue?vue&type=template&id=79af83ba&scoped=true&"
import script from "./MyPortfoliosWrapper.vue?vue&type=script&lang=js&"
export * from "./MyPortfoliosWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MyPortfoliosWrapper.vue?vue&type=style&index=0&id=79af83ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79af83ba",
  null
  
)

/* custom blocks */
import block0 from "@/translations/FinMyPortfolios.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc665095227%2Fsrc%2Ffincraft-app%2Fsrc%2Fcomponents%2Fpages%2FmyFinHub%2FfinPortfolios%2FMyPortfoliosWrapper.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
